import { ControlsToggleExtraContent, LayoutComponents } from "@jelly/lesson";
import config from "appConfig";

export const components: LayoutComponents = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/04/30/principle/714.svg`,
        },
      },
      styles: {
        padding: "4%",
      },
    },
  },
];

export const extraContent: ControlsToggleExtraContent = [
  {
    type: "audioButton",
    options: {
      text: "Amaze",
      icon: "cis-volume-high",
      shape: "round",
      theme: "secondary",
      url: `${config.ASSETS_URL}/04/30/principle/amaze-714.wav`,
    },
  },
  {
    type: "audioButton",
    options: {
      text: "Leaf",
      icon: "cis-volume-high",
      shape: "round",
      theme: "secondary",
      url: `${config.ASSETS_URL}/04/30/principle/leaf-714.wav`,
    },
  },
  {
    type: "audioButton",
    options: {
      text: "Santeria",
      icon: "cis-volume-high",
      shape: "round",
      theme: "secondary",
      url: `${config.ASSETS_URL}/04/30/principle/santeria-714.wav`,
    },
  },
];
